export default {
  message: {
    "error": "Đã xảy ra lỗi!",
    "Sorrysomeerrorsoccurred": "Xin lỗi, đã xảy ra một số lỗi",
    "quit": "Thoát",
    "language": "Ngôn ngữ",
    "Youcanchangethelanguagehere": "Bạn có thể thay đổi ngôn ngữ ở đây!",
    "current": "Hiện tại",
    "home": "Trang chính",
    "friends": "Bạn bè",
    "wallet": "Ví",
    "aboutus": "Về chúng tôi",
    "Sharewithfriends": "Chia sẻ với bạn bè",
    "copyFailure": "Sao chép thất bại",
    "copySuccess": "Sao chép thành công",
    "Claimreward": "Nhận thưởng",
    "DailyLogin": "Đăng nhập hàng ngày",
    "noInvitationsYet": "Chưa có lời mời nào",
    "LoadMore": "Tải thêm",
    "WatchAD": "Xem quảng cáo",
    "continue": "Tiếp tục",
    "Congratulations": "Chúc mừng",
    "MyFriends": "Bạn bè của tôi",
    "Invitefriends": "Mời bạn bè",
    "Invitepremiumfriends": "Mời bạn bè cao cấp",
    "DailyTasks": "Các nhiệm vụ hàng ngày",
    "inviteDesc": "+{num} ${name} cho mỗi người bạn bạn mời",
    "DailyTasksDesc": "Hoàn thành nhiệm vụ để nhận thêm ${name}",
    "SponsorsandPartners": "Các nhà tài trợ và đối tác",
    "Receivingwallet": "Ví nhận",
    "Enterwalletaddress": "Nhập địa chỉ ví {name}",
    "Claim": "Nhận",
    "Booster": "Tăng cường",
    "RentPeriod": "Thời gian thuê",
    "days30": "30 ngày",
    "days": "ngày",
    "Dailyprofit": "Lợi nhuận hàng ngày",
    "Totalprofit": "Tổng lợi nhuận",
    "Quantity": "Số lượng",
    "RentPrice": "Giá thuê",
    "RentMiner": "Thuê thợ mỏ",
    "Insufficient": "Không đủ ${name}",
    "InsufficientMsg": "Cần {num} ${name1}, mời bạn bè hoặc hoàn thành nhiệm vụ để kiếm thêm ${name2}.",
    "Settings": "Cài đặt",
    "copyid": "Sao chép ID",
    "UpgradeSuccessfully": "Nâng cấp thành công",
    "Name": "Tên",
    "userinfo": "Thông tin người dùng",
    "disconnect": "Ngắt kết nối",
    "Startmining": "Bắt đầu khai thác",
    "Welcome": "Chào mừng đến với {name}",
    "Withdrawal": "Rút tiền",
    "Minimumamount": "Số tiền tối thiểu",
    "Networkfee": "Phí mạng",
    "Enteramount": "Nhập số tiền",
    "Submit": "Gửi đi",
    "MinimumTip": "Số tiền rút quá nhỏ. Số tiền rút tối thiểu: {num}",
    "MaximumTip": "Số tiền không đủ, số tiền tối đa bạn có thể rút là: {num}",
    "SubmittedTip": "Đã gửi, dự kiến sẽ được xử lý trong vòng 30-60 ngày làm việc",
    "WebSubmittedTip": "Đã gửi, dự kiến sẽ được xử lý trong vòng 24-48 giờ",
    "WithdrawStatus": "Trạng thái",
    "Submissiontime": "Thời gian gửi",
    "WithdrawAwaitTip": "* Dự kiến sẽ mất 30-60 ngày làm việc. Mời thêm bạn bè có thể giúp tăng tốc độ xem xét.",
    "WebWithdrawAwaitTip": "* Dự kiến sẽ mất 24-48 giờ. Mời thêm bạn bè có thể giúp tăng tốc độ xem xét.",
    "Processing": "Đang xử lý",
    "Success": "Thành công",
    "Rejection": "Bị từ chối",
    "Amount": "Số tiền",
    "Numberoffriends": "Số lượng bạn bè: {now}/{limit}",
    "InviteTip": "Để thực hiện lần rút tiền đầu tiên, bạn cần mời {limit} bạn bè tham gia ứng dụng khai thác.",
    "openonphone": "Mở liên kết này trên điện thoại của bạn.",
    "claimTip": "Số tiền cần nhận quá nhỏ. Số tiền tối thiểu cần nhận là: {num}",
    "WalletBalance": "Số dư ví",
    "Withdraw": "Rút tiền",
    "SetWalletAddress": "Đặt địa chỉ ví",
    "WithdrawalRecord": "Ghi chép rút tiền",
    "Norecords": "Không có ghi chép",
    "Whatis": "{name} là gì?",
    "All": "Tất cả",
    "save": "Lưu",
    "successWithdrawal": "Rút tiền đã được nhận {num}",
    "secondsago": "{time} giây trước",
    "Loading": "Đang tải...",
    "PaymentConfirming": "Kiểm tra trạng thái giao dịch...",
    "Check": "Kiểm tra",
    "CheckFail": "Giao dịch chưa hoàn tất. Vui lòng kiểm tra lại sau 5 giây.",
    "Addname": "Thêm '{name}' vào tên của bạn",
    "Restattcheck": "Khởi động lại ứng dụng để kiểm tra",
    "Copyname": "Sao chép '{name}'",
    "SubmissionFailed": "Gửi đi thất bại, vui lòng thử lại sau",
    "WithdrawalReview": "Xem xét rút tiền",
    "shop": "Cửa hàng",
    "topurchase": "Đi đến cửa hàng để mua hàng",
    "shopDesc": "Số lượng có hạn—nhận ngay trước khi hết!",
    "select_payment_method": "Chọn phương thức thanh toán",
    "total_amount": "Tổng số tiền",
    "creating_order": "Đang tạo đơn hàng...",
    "order_created": "Đơn hàng đã được tạo",
    "order_status": "Trạng thái đơn hàng",
    "claim": "Nhận thưởng",
    "payment_success": "Thanh toán thành công",
    "payment_failed": "Thanh toán thất bại",
    "payment_cancelled": "Thanh toán đã bị hủy",
    "opening_payment": "Đang mở thanh toán...",
    "payment_status": "Trạng thái thanh toán",
    "create_order_failed": "Không thể tạo đơn hàng",
    "creating_ton_order": "Đang tạo đơn hàng TON...",
    "next_step": "Bước tiếp theo",
    "use_ton_payment": "Sử dụng thanh toán TON",
    "start_transaction": "Bắt đầu giao dịch",
    "connect_wallet": "Kết nối ví",
    "address": "Địa chỉ",
    "amount_ton": "Số tiền TON",
    "copy": "Sao chép",
    "amount": "Số tiền",
    "wallet_address": "Địa chỉ ví",
    "comment_memo": "Ghi chú",
    "you_can_choose_to_connect_wallet_to_pay": "Bạn có thể chọn kết nối ví để thanh toán",
    "or_manually_transfer_to_the_above_address": "Hoặc chuyển khoản thủ công đến địa chỉ trên (lưu ý rằng số tiền và ghi chú phải hoàn toàn giống nhau)",
    "transaction_success": "Giao dịch thành công",
    "transaction_failed": "Giao dịch không thành công",
    "transaction_error": "Lỗi giao dịch",
    "transaction_status": "Trạng thái giao dịch",
    "transaction_id": "ID giao dịch",
    "transaction_amount": "Số tiền giao dịch",
    "transaction_status_desc": "Mô tả trạng thái giao dịch",
    "payment_status_tip": "Xin vui lòng chờ đợi để thanh toán được xác nhận",
    "Applyforwithdrawal": "Xin rút tiền",
    "Withdrawalunlock": "Đang mở khóa rút tiền",
    "Close": "Đóng",
    "Delivering": "Đang giao hàng",
    "Duetothelargenumber": "Do số lượng người nhận lớn, airdrop của bạn dự kiến sẽ đến trong 15-20 ngày làm việc",
    "WithdrawalunlockTip": "Bạn cần {num} bạn bè được mời để hoàn thành nhiệm vụ/liên kết ví để mở khóa rút tiền",
    "select_network": "Chọn mạng",
    "confirm": "Xác nhận",
    "switching_network": "Đang chuyển mạng...",
    "network_switched": "Mạng đã được chuyển",
    "use_usdt_payment": "Sử dụng thanh toán USDT",
    "or_manually_transfer_to_the_above_address_usdt": "Chuyển tay đến địa chỉ trên (lưu ý rằng số tiền và địa chỉ phải hoàn toàn giống nhau)",
    "chain_type": "Mạng lưới",
    "check_transaction_status": "Kiểm tra trạng thái giao dịch",
    "transaction_wait": "Giao dịch đang được xử lý. Bạn có thể thoát ứng dụng. Một thông báo sẽ thông báo cho bạn khi nó hoàn tất.",
    "twa_pay_tip_with_memo": "Vui lòng đảm bảo rằng địa chỉ, số tiền và ghi chú là nhất quán cho việc chuyển tiền.",
    "twa_pay_tip": "Vui lòng đảm bảo rằng địa chỉ và số tiền là chính xác cho việc chuyển tiền.",
    "creating_usdt_order": "Đang tạo đơn hàng USDT...",
    "affiliate_programs": "Chương trình liên kết",
    "affiliate_programs_description": "Gửi lời mời bạn bè tham gia ứng dụng khai thác và nhận thưởng.",
    "commission_details": "Chi tiết hoa hồng",
    "no_commission_records": "Không có hồ sơ hoa hồng",
    "commission_list": "Danh sách hoa hồng",
    "input_amount": "Nhập số tiền",
    "max": "Tối đa",
    "commission_input_amount": "Nhập số tiền hoa hồng",
    "min_commission": "Số tiền rút tối thiểu là {num}",
    "WithdrawalSuccess": "Rút tiền thành công",
    "WithdrawalFailed": "Rút tiền không thành công",
    "WithdrawalProcessing": "Đang xử lý rút tiền",
    "award": "Giải thưởng",
    "level": "Cấp độ",
    "Share_to_group": "Chia sẻ vào nhóm",
    "Exchange": "Đổi",
    "balance_not_enough": "Không đủ số dư, bạn chỉ có thể đổi {num} {coin}",
    "exchange_fail": "Đổi không thành công",
    "exchange_success": "Đổi thành công",
    "you_will_receive": "Bạn sẽ nhận được",
    "ShareToGroups": "Chia sẻ tới nhóm",
    "Numberofgroups": "Số nhóm: {now}/{limit}",
    "Confirm": "Xác nhận",
    "ShareToGroupsDesc": "Chia sẻ tới nhóm để nhận thêm {name}",
    "TokenAddress": "Vui lòng nhập thông tin rút tiền như ID giao dịch hoặc địa chỉ USDT",
    "CashAddress": "Vui lòng nhập thông tin rút tiền như số thẻ ngân hàng hoặc địa chỉ USDT",
    "Cancel": "Hủy",
    "min_withdrawal_amount": "Số tiền rút tối thiểu là {num} {coin}",
    "max_withdrawal_amount": "Số tiền rút tối đa là {num} {coin}",
    "withdrawal_failed": "Rút tiền thất bại",
    "withdrawal_success": "Rút tiền thành công",
    "PayNow": "Thanh toán ngay",
    "PaySkip": "Thanh toán {num} để mở khóa rút tiền ngay lập tức",
    "NumberofGroups": "Số nhóm: {now}/{limit}",
    "SendMessage": "Gửi tin nhắn",
    "NumberofShares": "Số lượt chia sẻ: {now}/{limit}",
    "NumberofTasks": "Số nhiệm vụ: {now}/{limit}",
    "CompleteTask": "Hoàn thành nhiệm vụ",
    "PleaseEnterValidAmount": "Vui lòng nhập số tiền hợp lệ",
    "PleaseEnterValidEmail": "Vui lòng nhập email hợp lệ",
    "Feedback": "Phản hồi",
    "Inputfeedbackcontent": "Nhập nội dung phản hồi",
    "Submitfeedback": "Gửi phản hồi",
    "Pleaseenteravalidemailaddress": "Vui lòng nhập địa chỉ email hợp lệ",
    "Pleaseenteryouremailaddress": "Vui lòng nhập địa chỉ email của bạn",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Bạn đã gửi phản hồi hôm nay, vui lòng trở lại vào ngày mai",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Phản hồi đã được gửi thành công, cảm ơn bạn về phản hồi quý giá của bạn",
    "Feedback_submission_failed_please_retry": "Gửi phản hồi thất bại, vui lòng thử lại",
    "ContactUs": "Liên hệ với chúng tôi",
    "XRPAddress": "Vui lòng điền địa chỉ ví chuỗi XRP đã kích hoạt (bao gồm MEMO), nếu không bạn sẽ không thể rút tiền mặt.",
    "Accelerated": "Tăng tốc",
    "Accelerated_withdrawals_success": "Rút tiền tăng tốc thành công",
    "login": "Đăng nhập",
    "register": "Đăng ký",
    "login_with_google": "Đăng nhập bằng Google",
    "or": "HOẶC",
    "email": "Email",
    "password": "Mật khẩu",
    "no_account": "Bạn chưa có tài khoản",
    "click_to_go": "Nhấn để",
    "have_account": "Đã có tài khoản",
    "go_to": "Đi đến",
    "invite_code": "Mã mời",
    "optional": "Tùy chọn",
    "google_login_not_ready": "Đăng nhập bằng Google chưa sẵn sàng, vui lòng thử lại sau",
    "password_too_long": "Mật khẩu quá dài",
    "weak": "Yếu",
    "medium": "Trung bình",
    "strong": "Mạnh",
    "login_success": "Đăng nhập thành công",
    "login_failed": "Đăng nhập thất bại",
    "please_input_email": "Vui lòng nhập email của bạn",
    "invalid_email": "Định dạng email không hợp lệ",
    "please_input_password": "Vui lòng nhập mật khẩu của bạn",
    "password_length_6_to_16": "Mật khẩu phải từ 6-16 ký tự",
    "account_or_password_error": "Lỗi tài khoản hoặc mật khẩu",
    "register_success": "Đăng ký thành công",
    "register_failed": "Đăng ký thất bại",
    "save_error": "Lỗi lưu, vui lòng thử lại sau",
    "ShareToFriends": "Chia sẻ với bạn bè",
    "login_first": "Vui lòng đăng nhập trước",
    "WalletBscError": "❌ Địa chỉ ví BNB Chain không hợp lệ.",
    "DownloadWallet": "Tải Ví",
    "AddToHomeScreen": "Thêm {appName} vào màn hình chính",
    "TapShareInToolbar": "Chạm vào thanh công cụ",
    "SelectAddToHomeScreen": "Chọn thêm vào màn hình chính",
    "OpenToolbar": "Mở thanh công cụ",
    "ClaimFailed": "Nhận thưởng không thành công, vui lòng thử lại sau",
    "guest_login": "Đăng nhập khách",
    "please_input_phone": "Vui lòng nhập số điện thoại của bạn",
    "email_error_1": "Vui lòng nhập email của bạn",
    "email_error_2": "Vui lòng nhập địa chỉ email hợp lệ",
    "email_error_3": "Email khách không được phép, vui lòng sử dụng email thật",
    "phone": "Số điện thoại",
    "phone_error_1": "Vui lòng nhập số điện thoại của bạn",
    "phone_error_2": "Vui lòng nhập số điện thoại hợp lệ",
    "update_info": "Cập nhật thông tin",
    "update_success": "Đã cập nhật thành công",
    "update_failed": "Cập nhật không thành công, vui lòng thử lại sau",
    "cancel": "Hủy",
    "guest_credentials_title": "Thông tin tài khoản",
    "guest_credentials_warning": "Vui lòng chụp màn hình để lưu tài khoản và mật khẩu của bạn. Nếu mất, thu nhập của bạn sẽ không thể khôi phục!",
    "i_have_saved": "Tôi đã lưu",
    "account": "Tài khoản",
    "view_credentials": "Xem thông tin đăng nhập",
    "miner_max_reached": "Bạn đã đạt tới số lượng tối đa của thợ mỏ này"
}};